export default __webpack_public_path__ + "static/media/mbr-1-1920x1281.fd011980.jpeg";